/* Sticker Mania V2 runtime — vanilla port of the landing design's behavior.
   Handles: scroll reveals, ambient orbs, scroll progress, section dimming,
   scroll cue, sticky bottom CTA, stats count-up, pinned steps, pricing calc, FAQ.
   Safe to include from multiple sections (self-guards). Re-inits on Shopify editor events. */
(function () {
  if (window.SMV2) return;
  var SMV2 = window.SMV2 = { els: {}, state: { step: -1, statsRan: false } };
  SMV2.reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- scroll reveals ---------- */
  var rio = new IntersectionObserver(function (ents) {
    ents.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('smr-in');
        if (e.target.hasAttribute('data-sm-stats')) runStats(e.target);
        rio.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });

  function scanReveals() {
    $all('[style*="--reveal"]').forEach(function (el) {
      if (el._smr) return; el._smr = true;
      var kind = (el.style.getPropertyValue('--reveal') || 'up').trim();
      el.classList.add('smr');
      if (kind !== 'up') el.classList.add('smr-' + kind);
      var sibs = el.parentElement ? $all(':scope > *', el.parentElement).filter(function (c) {
        return (c.getAttribute('style') || '').indexOf('--reveal') !== -1;
      }) : [];
      if (sibs.length > 1) el.style.transitionDelay = (sibs.indexOf(el) % 6) * 70 + 'ms';
      rio.observe(el);
    });
  }

  /* ---------- stats count-up ---------- */
  function runStats(wrap) {
    if (wrap._statsRan) return; wrap._statsRan = true;
    var stats = $all('[data-stat-num]', wrap);
    var t0 = performance.now(), dur = 1300;
    function tick(now) {
      var p = Math.min(1, (now - t0) / dur);
      var t = 1 - Math.pow(1 - p, 3);
      stats.forEach(function (el) {
        var num = parseFloat(el.getAttribute('data-stat-num'));
        var dec = parseInt(el.getAttribute('data-stat-dec') || '0', 10);
        var suffix = el.getAttribute('data-stat-suffix') || '';
        if (isNaN(num)) { el.textContent = t > 0.5 ? (el.getAttribute('data-stat-text') || '') : '·'; return; }
        var v = num * t;
        el.textContent = (dec ? v.toFixed(dec) : Math.round(v).toLocaleString('en-US')) + suffix;
      });
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* ---------- global scroll frame ---------- */
  function cache() {
    SMV2.els = {
      cue: $('[data-scroll-cue]'),
      bar: $('[data-sticky-cta]'),
      end: $('[data-sm-cta-end]'),
      prog: $('[data-progress]'),
      orbs: $all('[data-orb]'),
      pins: $all('[data-sm-steps-pin]'),
      secs: $all('[data-sm-sec]')
    };
  }

  function frame() {
    SMV2.ticking = false;
    var E = SMV2.els, y = window.scrollY, vh = window.innerHeight;
    if (E.cue) E.cue.style.opacity = y > 60 ? '0' : '1';
    if (E.bar) {
      var nearEnd = E.end && E.end.getBoundingClientRect().top < vh;
      var barShown = (y > vh * 0.9 && !nearEnd);
      E.bar.style.transform = 'translate(-50%,' + (barShown ? '0%' : '110%') + ')';
      // when slid off-screen its links must leave the tab order and a11y tree —
      // being position:fixed they can't be scrolled to, so focus would vanish
      if (barShown) { E.bar.removeAttribute('inert'); E.bar.removeAttribute('aria-hidden'); }
      else { E.bar.setAttribute('inert', ''); E.bar.setAttribute('aria-hidden', 'true'); }
    }
    if (E.prog) {
      var max = document.documentElement.scrollHeight - vh;
      E.prog.style.width = (max > 0 ? Math.min(100, (y / max) * 100) : 0) + '%';
    }
    // reduced-motion users get static orbs (WCAG 2.2.2) — reelGlide/beforeAfter
    // already honour this; the orbs did not
    if (!SMV2.reduced) {
      E.orbs.forEach(function (o, i) {
        var f = parseFloat(o.getAttribute('data-orb'));
        var ty = Math.sin(y * 0.0009 + i * 2.1) * 110 + y * f * 0.2;
        var tx = Math.cos(y * 0.0007 + i * 1.7) * 70;
        var sc = 1 + Math.sin(y * 0.001 + i) * 0.1;
        o.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + sc + ')';
      });
    }
    E.pins.forEach(function (pin) {
      var r = pin.getBoundingClientRect();
      var total = r.height - vh;
      var p = Math.min(1, Math.max(0, -r.top / total));
      var count = $all('[data-step-panel]', pin).length || 4;
      var step = Math.min(count - 1, Math.floor(p * count));
      if (pin._step !== step) { pin._step = step; setStep(pin, step); }
    });
    if (E.secs.length) {
      var mid = vh / 2, best = null, bestD = Infinity;
      E.secs.forEach(function (s) {
        var r = s.getBoundingClientRect();
        var d = (r.top <= mid && r.bottom >= mid) ? 0 : Math.min(Math.abs(r.top - mid), Math.abs(r.bottom - mid));
        if (d < bestD) { bestD = d; best = s; }
      });
      E.secs.forEach(function (s) { s.classList.toggle('sm-dim', s !== best); });
    }
  }

  function setStep(pin, step) {
    $all('[data-step-panel]', pin).forEach(function (el, i) {
      el.style.opacity = i === step ? 1 : 0;
      el.style.zIndex = i === step ? 2 : 1;
    });
    $all('[data-step-copy]', pin).forEach(function (el, i) {
      el.style.opacity = i === step ? 1 : 0;
      el.style.transform = 'translateY(' + (i === step ? '0px' : (i < step ? '-16px' : '16px')) + ')';
    });
    $all('[data-step-bar]', pin).forEach(function (el, i) {
      el.style.background = i <= step ? '#1b4dff' : 'rgba(255,255,255,.14)';
    });
    var n = $('[data-step-n]', pin);
    if (n) n.textContent = '0' + (step + 1);
    // index by PANEL, not by video — image-only steps would shift the video list
    $all('[data-step-panel]', pin).forEach(function (panel, i) {
      var v = $('video', panel);
      if (!v) return;
      if (i === step) { v.play && v.play().catch(function () {}); } else { v.pause && v.pause(); }
    });
  }

  function onScroll() {
    if (SMV2.ticking) return;
    SMV2.ticking = true;
    requestAnimationFrame(frame);
  }

  /* ---------- steps nav: arrows / tap / bar-click scrub the pinned steps ----------
     The steps are scroll-driven, so every control simply scrolls the window to the
     matching point in the pin range — controls and scroll stay one system. */
  function initStepsNav() {
    $all('[data-sm-steps-pin]').forEach(function (pin) {
      if (pin._nav) return; pin._nav = true;
      var count = $all('[data-step-panel]', pin).length;
      function goto(step) {
        var top = pin.getBoundingClientRect().top + window.scrollY;
        if (step >= count) {
          // already on the last step — nudge onward to the next section
          window.scrollTo({ top: Math.round(top + pin.offsetHeight - 86), behavior: 'smooth' });
          return;
        }
        step = Math.max(0, step);
        var total = pin.offsetHeight - window.innerHeight;
        window.scrollTo({ top: Math.round(top + ((step + 0.5) / count) * total), behavior: 'smooth' });
      }
      // $all, not $: there are TWO pairs now — the header arrows (desktop) and the
      // overlay controls on the stage (mobile, .smv2-stepnav). CSS decides which pair
      // is visible; both need the handler, and $ would only ever bind the first.
      // stopPropagation is load-bearing: the mobile pair sits INSIDE [data-step-stage],
      // which has its own advance-on-click handler below, so without it one tap fires
      // the button AND the stage and jumps two steps.
      $all('[data-step-prev]', pin).forEach(function (b) {
        b.addEventListener('click', function (e) { e.stopPropagation(); goto((pin._step || 0) - 1); });
      });
      $all('[data-step-next]', pin).forEach(function (b) {
        b.addEventListener('click', function (e) { e.stopPropagation(); goto((pin._step || 0) + 1); });
      });
      var stage = $('[data-step-stage]', pin);
      if (stage) stage.addEventListener('click', function (e) {
        // story-style: left 40% steps back, right 60% steps forward
        var r = stage.getBoundingClientRect();
        var back = (e.clientX - r.left) < r.width * 0.4;
        goto((pin._step || 0) + (back ? -1 : 1));
      });
      $all('[data-step-bar]', pin).forEach(function (bar, i) {
        bar.addEventListener('click', function () { goto(i); });
      });
    });
  }

  /* ---------- pricing calculator ---------- */
  function initPricing(root) {
    $all('[data-smv2-pricing]', root || document).forEach(function (el) {
      if (el._init) return; el._init = true;
      var dataEl = $('script[type="application/json"]', el);
      if (!dataEl) return;
      var sizes; try { sizes = JSON.parse(dataEl.textContent).sizes; } catch (e) { return; }
      if (!sizes || !sizes.length) return;
      var defLabel = el.getAttribute('data-default-size') || '';
      var defIdx = Math.max(0, sizes.map(function (s) { return s.label; }).indexOf(defLabel));
      // Which tier greets you. Targeting a DISCOUNT rather than a fixed index
      // keeps the headline honest if the ladder ever gains or loses a step —
      // index 2 silently meant 40% here, not the 50% it was meant to show.
      var targetPct = parseFloat(el.getAttribute('data-default-discount'));
      if (!isFinite(targetPct)) targetPct = 50;
      function defaultTier(t) {
        var base = t[0].ea, best = t[0], bestD = Infinity;
        t.forEach(function (x) {
          var d = Math.abs((1 - x.ea / base) * 100 - targetPct);
          if (d < bestD) { bestD = d; best = x; }
        });
        return best;
      }
      var state = { size: defIdx, qty: null };
      var chips = $all('[data-size-chip]', el);
      var tabsWrap = $('[data-qty-tabs]', el);
      var priceEl = $('[data-unit-price]', el), savEl = $('[data-savings]', el);
      var totEl = $('[data-total-line]', el), noteEl = $('[data-size-note]', el);
      function fmtQ(q) { return q >= 1000 ? q.toLocaleString('en-US') : String(q); }
      function cur() {
        var t = sizes[state.size].tiers;
        return t.filter(function (x) { return x.q === state.qty; })[0] || defaultTier(t);
      }
      function render() {
        var s = sizes[state.size], t = s.tiers, c = cur();
        chips.forEach(function (ch, i) {
          var on = i === state.size;
          ch.style.border = on ? '1px solid #1b4dff' : '1px solid rgba(255,255,255,.16)';
          ch.style.background = on ? '#1b4dff' : 'transparent';
          ch.style.color = on ? '#fff' : 'rgba(255,255,255,.7)';
          ch.setAttribute('aria-pressed', on ? 'true' : 'false');   // selection was colour-only
        });
        if (noteEl) noteEl.textContent = s.note + ' Prices shown are for ' + s.label + '.';
        if (tabsWrap) {
          tabsWrap.innerHTML = '';
          t.forEach(function (tier, i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.textContent = fmtQ(tier.q);
            var on = tier.q === c.q;
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
            b.setAttribute('aria-label', fmtQ(tier.q) + ' ' + (s.label || 'bags'));
            b.style.cssText = "flex:1;cursor:pointer;border:none;font:800 14px 'Manrope';padding:17px 4px;transition:all .15s;" +
              (i < t.length - 1 ? 'border-right:1px solid rgba(255,255,255,.1);' : '') +
              (on ? 'background:#1b4dff;color:#fff;' : 'background:transparent;color:rgba(255,255,255,.5);');
            b.addEventListener('click', function () { state.qty = tier.q; render(); });
            tabsWrap.appendChild(b);
          });
        }
        if (priceEl) {
          priceEl.textContent = '$' + c.ea.toFixed(2);
          priceEl.style.animation = 'none'; void priceEl.offsetWidth;
          priceEl.style.animation = 'pop .3s ease';
        }
        var pct = Math.round((1 - c.ea / t[0].ea) * 100);
        if (savEl) savEl.textContent = pct > 0 ? ('Save ' + pct + '% vs. the minimum order') : ('Our lowest minimum for ' + s.label);
        if (totEl) totEl.textContent = fmtQ(c.q) + ' bags · $' + (c.ea * c.q).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' total';
      }
      chips.forEach(function (ch, i) {
        ch.addEventListener('click', function () {
          state.size = i;
          var t = sizes[i].tiers;
          state.qty = defaultTier(t).q;
          render();
        });
      });
      state.qty = null; render();
    });
  }

  /* ---------- universal header: mobile menu ---------- */
  function initHeader(root) {
    $all('[data-smv2-burger]', root || document).forEach(function (btn) {
      if (btn._init) return; btn._init = true;
      var panel = $('[data-smv2-mobile]', btn.closest('.dk-pill'));
      if (!panel) return;
      function close() {
        panel.classList.remove('is-open');
        btn.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        panel._hideT = setTimeout(function () { panel.setAttribute('hidden', ''); }, 300);
      }
      btn.addEventListener('click', function () {
        clearTimeout(panel._hideT);
        if (panel.classList.contains('is-open')) { close(); return; }
        panel.removeAttribute('hidden');
        void panel.offsetHeight; // reflow so the open transition actually runs
        panel.classList.add('is-open');
        btn.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      });
      panel.addEventListener('click', function (e) { if (e.target.tagName === 'A') close(); });
      // Accordion groups (nested menu items). The toggle is a BUTTON, so the
      // close-on-link-tap handler above ignores it; only real navigations
      // dismiss the panel.
      $all('[data-smv2-subtoggle]', panel).forEach(function (tg) {
        tg.addEventListener('click', function () {
          var open = tg.classList.toggle('is-open');
          tg.setAttribute('aria-expanded', open ? 'true' : 'false');
          var group = tg.nextElementSibling;
          if (group && group.classList.contains('smv2-subnav')) group.classList.toggle('is-open', open);
        });
      });
      // Escape closes and returns focus to the burger; an outside tap closes too
      // (the panel had neither, so an opened menu could only be dismissed by the
      // burger — and on rotate-to-landscape the burger can vanish).
      document.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.key === 'Esc') && panel.classList.contains('is-open')) { close(); btn.focus(); }
      });
      document.addEventListener('click', function (e) {
        if (!panel.classList.contains('is-open')) return;
        if (btn.contains(e.target) || panel.contains(e.target)) return;
        close();
      });
    });
  }

  /* ---------- portfolio lightbox (custom design works) ---------- */
  function initWorkLightbox() {
    if (SMV2._lbBound) return; SMV2._lbBound = true;
    var lastFocus = null;
    function lbEl() { return $('[data-cdw-lightbox]'); }
    function close() {
      var lb = lbEl(); if (!lb) return;
      lb.setAttribute('hidden', ''); lb.removeAttribute('aria-modal');
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
      lastFocus = null;
    }
    document.addEventListener('click', function (e) {
      var lb = lbEl();
      if (!lb) return;
      var btn = e.target.closest('[data-cdw-open]');
      if (btn) {
        var src2 = btn.getAttribute('data-img');
        if (!src2) return;
        $('[data-cdw-img]', lb).src = src2;
        var plain = btn.getAttribute('data-cap');
        var d = btn.getAttribute('data-designer'), h = btn.getAttribute('data-handle');
        $('[data-cdw-cap]', lb).innerHTML = plain ? plain.replace(/</g, '&lt;')
          : (d ? ('Designed by ' + d + (h ? ' · <a href="https://instagram.com/' + h + '" target="_blank" rel="noopener" style="color:#8fa5ff;text-decoration:none;">@' + h + '</a>' : '')) : '');
        lb.removeAttribute('hidden');
        lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
        document.documentElement.style.overflow = 'hidden';
        // move focus into the dialog and remember what to return it to on close
        lastFocus = btn;
        var closeBtn = $('[data-cdw-close]', lb);
        if (closeBtn) closeBtn.focus();
        return;
      }
      if (e.target.closest('[data-cdw-close]') || e.target === lb) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var lb = lbEl(); if (lb && !lb.hasAttribute('hidden')) close();
    });
  }

  /* ---------- reel video: defer the download, then pause while off-screen ----------
     home-work-reel ships its clips as data-wr-src with preload="none" and no
     autoplay, so page load fetches ZERO video bytes for a section that begins
     ~2600px down. This observer is what turns them on. Videos rendered with a
     real src (any other reel) still just get the play/pause management. */
  function loadReelVideo(v) {
    var ds = v.getAttribute('data-wr-src');
    /* guard on the attribute, not .src: an unset <video> reports src === '' but
       assigning twice restarts the fetch */
    if (ds && !v.getAttribute('src')) { v.muted = true; v.src = ds; v.load(); }
  }
  function initReelPower() {
    if (SMV2._reelPower) return; SMV2._reelPower = true;
    var vids = $all('.smv2-reel-track video');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      /* no observer: fall back to the old eager behaviour rather than stranding
         every tile on its poster forever */
      vids.forEach(function (v) {
        loadReelVideo(v);
        if (!SMV2.reduced) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
      return;
    }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        var v = en.target;
        if (!en.isIntersecting) { if (!v.paused) v.pause(); return; }
        /* reduced motion never plays, so it never pays for the bytes either —
           the poster is a real frame and stands on its own */
        if (SMV2.reduced) return;
        loadReelVideo(v);
        if (v.paused) v.play().catch(function () {});
      });
    }, { rootMargin: '120px 240px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- work-reel popout: flip the info panel near the right edge ---------- */
  function decideReel(item, lockedFlip) {
    var clipper = item.closest('.smv2-reel-track');
    var box = clipper && clipper.parentElement ? clipper.parentElement.getBoundingClientRect() : { left: 0, right: window.innerWidth };
    var PAD = 24, PANEL = 284, W = 536, GAP = 4;
    // resting slot/media width comes from the CSS token (200px on phones)
    var MEDIA = parseFloat(getComputedStyle(item).getPropertyValue('--wr-w')) || 252;
    // The slot's live rect lies while a neighbor is mid-collapse (a previous
    // hover shrinking 536→252 shifts everything after it by up to 284px), so
    // derive the RESTING left analytically: track edge + index × (slot+gap).
    var left = item.getBoundingClientRect().left;
    if (clipper) {
      var idx = Array.prototype.indexOf.call(clipper.children, item);
      if (idx > -1) left = clipper.getBoundingClientRect().left + GAP + idx * (MEDIA + GAP);
    }
    // narrow (touch) containers: the card expands full-bleed instead — just
    // align the item flush with the container and skip the flip logic
    if (box.right - box.left < W + PAD * 2) {
      item.classList.remove('wr-flip');
      item.style.setProperty('--wr-tx', Math.round(box.left - left) + 'px');
      return;
    }
    // move the VIDEO only as much as its own visibility requires...
    var fix = 0;
    if (left + MEDIA > box.right - PAD) fix = (box.right - PAD) - (left + MEDIA);
    if (left + fix < box.left + PAD) fix = (box.left + PAD) - left;
    // ...then open the panel on whichever side has room. Flipped slots expand
    // leftward via margin (see section CSS), so the media rests in place and
    // tx is just the visibility fix in both orientations. A re-decide after
    // the marquee glides to a stop passes lockedFlip so the panel can't hop.
    var panelRight = lockedFlip === undefined ? left + fix + W <= box.right - PAD : !lockedFlip;
    var tx = fix;
    if (!panelRight && left - PANEL + tx < box.left + PAD) {
      // narrow-container fallback: no room on the left either — full-fit shift
      item.classList.remove('wr-flip');
      tx = (box.right - PAD) - (left + W);
      if (left + tx < box.left + PAD) tx = (box.left + PAD) - left;
    } else {
      item.classList.toggle('wr-flip', !panelRight);
    }
    item.style.setProperty('--wr-tx', Math.round(tx) + 'px');
  }
  function initReelFlip() {
    if (SMV2._flipBound) return; SMV2._flipBound = true;
    // Decide ONCE per hover, from the sliver's resting position, and lock it
    // until the collapse transition has finished — re-deciding mid-hover
    // (when the item is transformed) made the panel hop sides.
    document.addEventListener('mouseenter', function (e) {
      if (!e.target || !e.target.closest) return;
      var item = e.target.closest('.wr-slot');
      if (!item) return;
      item.classList.remove('wr-closing');
      if (item._flipLock) return;
      item._flipLock = true;
      clearTimeout(item._flipUnlock);
      decideReel(item);
    }, true);
    document.addEventListener('mouseleave', function (e) {
      if (!e.target || !e.target.closest) return;
      var item = e.target.closest ? e.target.closest('.wr-slot') : null;
      if (!item || e.target !== item) return;
      // wr-closing keeps the collapsing card above resting slivers but below
      // any newly hovered card (z tiers in the section CSS)
      item.classList.add('wr-closing');
      clearTimeout(item._flipUnlock);
      item._flipUnlock = setTimeout(function () { item._flipLock = false; item.classList.remove('wr-closing'); }, 560);
    }, true);
  }

  /* ---------- marquee glide: ease the reel to a stop instead of freezing ---------- */
  function initReelGlide() {
    $all('.smv2-reel-track').forEach(function (track) {
      if (track._glide) return; track._glide = true;
      var cur = 1, target = 1, raf = 0;
      var instant = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      function step() {
        raf = 0;
        var a = (track.getAnimations ? track.getAnimations() : [])[0];
        if (!a) return;
        cur = instant ? target : cur + (target - cur) * 0.16;
        if (Math.abs(cur - target) < 0.02) cur = target;
        a.playbackRate = cur;
        if (cur !== target) { raf = requestAnimationFrame(step); return; }
        // fully stopped: positions are final — refine the hovered slot's shift
        // (the reel drifted a few px during the glide), keeping its panel side
        if (target === 0) {
          var h = track.querySelector('.wr-slot:hover, .wr-slot.wr-open');
          if (h) decideReel(h, h.classList.contains('wr-flip'));
        }
      }
      function go(t) { target = t; if (!raf) raf = requestAnimationFrame(step); }
      track._glideTo = go;
      track.addEventListener('mouseenter', function () { go(0); });
      track.addEventListener('mouseleave', function () { go(1); });
    });
  }

  /* ---------- work-reel tap: touch devices toggle .wr-open instead of hover ---------- */
  function initReelTap() {
    if (SMV2._tapBound) return; SMV2._tapBound = true;
    if (!(window.matchMedia && matchMedia('(hover: none)').matches) && !('ontouchstart' in window)) return;
    function close(slot) {
      slot.classList.remove('wr-open');
      slot.classList.add('wr-closing');
      clearTimeout(slot._tapClosing);
      slot._tapClosing = setTimeout(function () { slot.classList.remove('wr-closing'); }, 560);
    }
    document.addEventListener('click', function (e) {
      var slot = e.target.closest ? e.target.closest('.wr-slot') : null;
      var openNow = $all('.wr-slot.wr-open');
      if (!slot) {
        if (openNow.length) {
          openNow.forEach(close);
          var t = document.querySelector('.smv2-reel-track');
          if (t && t._glideTo) t._glideTo(1);
        }
        return;
      }
      var track = slot.closest('.smv2-reel-track');
      if (slot.classList.contains('wr-open')) {
        close(slot);
        if (track && track._glideTo) track._glideTo(1);
        return;
      }
      if (openNow.length) {
        // a card is open: this tap can only dismiss it, never open another.
        // Taps land on whichever .wr-slot is under the finger, and the open
        // card's 100vw visual covers several of them — opening the one behind
        // it is never what the buyer meant.
        openNow.forEach(close);
        if (track && track._glideTo) track._glideTo(1);
        return;
      }
      if (track && track._glideTo) track._glideTo(0);
      decideReel(slot);
      slot.classList.add('wr-open');
    });
  }

  /* ---------- education quick-jump chips (built from the term cards) ---------- */
  function initEduJump() {
    var host = $('[data-edu-jump]');
    if (!host || host._init) return; if (host) host._init = true;
    var seen = {};
    $all('[data-smv2-scroller] [data-cdw-open][data-cap]').forEach(function (card) {
      var cap = card.getAttribute('data-cap');
      if (!cap || seen[cap]) return; seen[cap] = 1;
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.textContent = cap;
      // shared interactive token — CSS carries the hover (gated for touch) and
      // the 44px target, instead of inline styles plus mouseenter/mouseleave
      chip.className = 'smv2-pill';
      chip.addEventListener('click', function () { card.click(); });
      host.appendChild(chip);
    });
  }

  /* ---------- horizontal scroller arrows ---------- */
  function initScrollers(root) {
    $all('[data-smv2-scroller]', root || document).forEach(function (sc) {
      if (sc._init) return; sc._init = true;
      var wrap = sc.closest('section') || sc.parentElement;
      var prev = $('[data-scroll-prev]', wrap), next = $('[data-scroll-next]', wrap);
      var step = function () { var card = sc.firstElementChild; return card ? (card.getBoundingClientRect().width + 14) * 2 : sc.clientWidth * 0.8; };
      if (prev) prev.addEventListener('click', function () { sc.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { sc.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq(root) {
    $all('[data-smv2-faq]', root || document).forEach(function (wrap) {
      if (wrap._init) return; wrap._init = true;
      // split long FAQs into two INDEPENDENT columns (desktop) — a shared grid
      // made the row partner stretch when a question opened, which read as the
      // opposite question opening with no content
      var items = $all('[data-faq-item]', wrap);
      if (wrap.classList.contains('dk-faqw') && items.length > 5 && !wrap._split) {
        wrap._split = true;
        var colA = document.createElement('div'), colB = document.createElement('div');
        colA.className = 'smv2-faq-col'; colB.className = 'smv2-faq-col';
        var half = Math.ceil(items.length / 2);
        items.forEach(function (it, i) { (i < half ? colA : colB).appendChild(it); });
        wrap.appendChild(colA); wrap.appendChild(colB);
      }
      function setOpen(idx) {
        items.forEach(function (it, i) {
          var open = i === idx;
          var body = $('[data-faq-a]', it), icon = $('[data-faq-icon]', it), q = $('[data-faq-q]', it);
          if (body) {
            body.style.maxHeight = open ? body.scrollHeight + 'px' : '0px';
            body.style.opacity = open ? 1 : 0;
            // collapsed answers were only visually clipped (max-height:0), so a
            // screen reader still read all twelve as open. aria-hidden removes
            // the closed ones from the tree without breaking the CSS transition
            // the way display:none would.
            body.setAttribute('aria-hidden', open ? 'false' : 'true');
          }
          if (icon) icon.style.transform = open ? 'rotate(45deg)' : 'rotate(0deg)';
          if (q) q.setAttribute('aria-expanded', open ? 'true' : 'false');
          it._open = open;
        });
      }
      items.forEach(function (it, i) {
        var btn = $('[data-faq-q]', it);
        if (btn) btn.addEventListener('click', function () { setOpen(it._open ? -1 : i); });
      });
      setOpen(0);
    });
  }

  /* ---------- before/after reveal ---------- */
  function initBeforeAfter(root) {
    $all('[data-smv2-ba]', root || document).forEach(function (ba) {
      if (ba._init) return; ba._init = true;
      var grip = $('[data-smv2-ba-grip]', ba);
      var pos = 50, startX = 0, startY = 0, dragging = false, decided = false, down = false;

      function set(p) {
        pos = Math.max(0, Math.min(100, p));
        ba.style.setProperty('--ba', pos + '%');
        if (grip) grip.setAttribute('aria-valuenow', Math.round(pos));
        // hide whichever tag the seam is about to sit on top of
        ba.setAttribute('data-near', pos < 18 ? 'l' : (pos > 82 ? 'r' : ''));
      }
      function fromX(clientX) {
        var r = ba.getBoundingClientRect();
        return r.width ? ((clientX - r.left) / r.width) * 100 : 50;
      }
      function beginDrag(e) {
        dragging = true;
        ba.classList.add('smv2-ba-dragging');
        if (ba.setPointerCapture && e.pointerId != null) { try { ba.setPointerCapture(e.pointerId); } catch (err) {} }
      }

      ba.addEventListener('pointerdown', function (e) {
        down = true;
        startX = e.clientX; startY = e.clientY; decided = false; dragging = false;
        // the grip is an explicit handle — grab it immediately, no intent test
        if (grip && (e.target === grip || grip.contains(e.target))) { decided = true; beginDrag(e); set(fromX(e.clientX)); }
      });
      ba.addEventListener('pointermove', function (e) {
        // a plain mouse hover (no button held) must never move the seam — without
        // this the desktop reveal snapped to and followed the bare cursor
        if (!down) return;
        if (!decided) {
          var dx = Math.abs(e.clientX - startX), dy = Math.abs(e.clientY - startY);
          if (dx < 10 && dy < 10) return;
          decided = true;
          // vertical intent belongs to the page, not the slider
          if (dy > dx) return;
          beginDrag(e);
        }
        if (!dragging) return;
        e.preventDefault();
        set(fromX(e.clientX));
      });
      function endDrag(e) {
        // a clean tap with no drag jumps the seam to where they tapped
        if (!dragging && down && e && Math.abs(e.clientX - startX) < 10 && Math.abs(e.clientY - startY) < 10) set(fromX(e.clientX));
        down = false; dragging = false; decided = false;
        ba.classList.remove('smv2-ba-dragging');
      }
      ba.addEventListener('pointerup', endDrag);
      ba.addEventListener('pointercancel', function () { down = false; dragging = false; decided = false; ba.classList.remove('smv2-ba-dragging'); });

      if (grip) {
        grip.addEventListener('click', function (e) { e.preventDefault(); });
        grip.addEventListener('keydown', function (e) {
          var step = e.shiftKey ? 10 : 4;
          if (e.key === 'ArrowLeft') { set(pos - step); e.preventDefault(); }
          else if (e.key === 'ArrowRight') { set(pos + step); e.preventDefault(); }
          else if (e.key === 'Home') { set(0); e.preventDefault(); }
          else if (e.key === 'End') { set(100); e.preventDefault(); }
        });
      }

      set(50);
      // one-time nudge on first view so it reads as draggable, not as a static image
      if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var hint = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) {
            if (!en.isIntersecting || ba._hinted) return;
            ba._hinted = true; hint.unobserve(ba);
            var t0 = null;
            requestAnimationFrame(function tick(now) {
              if (t0 === null) t0 = now;
              var p = Math.min(1, (now - t0) / 1100);
              // out and back — a single sine sweep returns to 50% on its own
              set(50 + Math.sin(p * Math.PI) * 16);
              if (p < 1 && !dragging) requestAnimationFrame(tick);
            });
          });
        }, { threshold: 0.35 });
        hint.observe(ba);
      }
    });
  }

  /* ---------- live instagram feed ---------- */
  /* Progressive enhancement over the manual tiles: the grid ships rendered with
     whatever is set in the editor, and this only swaps content in once real
     posts arrive. Any failure — endpoint down, token dead, offline — leaves the
     manual tiles exactly as they were, so the grid is never empty. */

  function initIgFeed(root) {
    $all('[data-smv2-ig-feed]', root || document).forEach(function (grid) {
      if (grid._init) return; grid._init = true;
      var endpoint = grid.getAttribute('data-endpoint');
      if (!endpoint) return;
      var want = parseInt(grid.getAttribute('data-count') || '12', 10) || 12;

      /* reels that expose their MP4 (original-audio posts — Meta withholds
         media_url on licensed-music reels) autoplay muted in the tile, but
         only while on screen, and never under reduced motion or Save-Data. */
      var vidIO = null;
      function watchVideo(v) {
        if (!('IntersectionObserver' in window)) return;
        if (!vidIO) vidIO = new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            var vv = en.target;
            if (en.isIntersecting) {
              if (!vv.getAttribute('src')) vv.src = vv.getAttribute('data-src');
              var p = vv.play(); if (p && p.catch) p.catch(function () {});
            } else if (!vv.paused) vv.pause();
          });
        }, { threshold: 0.35 });
        vidIO.observe(v);
      }

      // 12400 -> 12.4K, 1200000 -> 1.2M — how Instagram itself reads
      function compact(n) {
        if (n >= 1000000) return (n / 1000000).toFixed(n % 1000000 === 0 ? 0 : 1).replace(/\.0$/, '') + 'M';
        if (n >= 1000) return (n / 1000).toFixed(n % 1000 === 0 ? 0 : 1).replace(/\.0$/, '') + 'K';
        return String(n);
      }

      function paintProfile(profile) {
        if (!profile) return;
        var section = grid.closest('section') || document;

        // follower count genuinely changes — live always wins over the typed value
        if (typeof profile.followers === 'number') {
          var stat = $('[data-ig-followers]', section);
          var num = $('[data-ig-followers-n]', section);
          if (num) num.textContent = compact(profile.followers);
          if (stat) stat.removeAttribute('hidden');
        }
        // post count, same deal (the IG-profile remake shows it in the stats row)
        if (typeof profile.posts === 'number') {
          var pn = $('[data-ig-posts-n]', section);
          if (pn) pn.textContent = compact(profile.posts);
        }
        // display name + bio: the live account text always wins, so the page
        // bio can never drift from the real one on Instagram
        if (profile.name) {
          var nm = $('[data-ig-name]', section);
          if (nm) nm.textContent = profile.name;
        }
        if (profile.bio) {
          var bo = $('[data-ig-bio]', section);
          if (bo) bo.textContent = profile.bio;
        }
        // avatar is the opposite: an uploaded logo never breaks, and Instagram's
        // CDN URLs are short-lived, so only fill in when nothing was uploaded
        var av = $('[data-ig-avatar]', section);
        if (av && profile.avatar && !av.getAttribute('src')) {
          /* The comment above is the whole reason this guard exists: when a logo IS
             uploaded we never touch the avatar, but when it is NOT (the vial page has
             no profile_image set) we fall through to a signed CDN URL that expires in
             ~5 days. Hide on failure so a stale feed leaves a clean empty ring rather
             than a broken-image icon inside it. The permanent fix is upstream —
             upload a profile_image and this branch never runs at all. */
          av.addEventListener('error', function () { this.style.display = 'none'; }, { once: true });
          av.src = profile.avatar;
          av.removeAttribute('hidden');
        }
      }

      function paint(items) {
        var tiles = $all('.smv2-ig-tile', grid);
        if (!tiles.length || !items.length) return;
        var template = tiles[0];

        items.forEach(function (post, i) {
          var tile = tiles[i];
          if (!tile) {
            // clone rather than build: keeps the inline styles, hover hint and
            // reveal classes identical to the authored markup
            tile = template.cloneNode(true);
            grid.appendChild(tile);
          }
          var img = $('img', tile);
          if (!img) return;
          tile.href = post.permalink;
          tile.setAttribute('aria-label', post.caption ? 'Instagram: ' + post.caption.slice(0, 80) : 'Open on Instagram');
          /* Instagram CDN URLs are SIGNED and expire — the `oe=` param is a hex
             timestamp, and the lifetime measured 2026-08-27 was ~5 days. If the feed
             goes stale for longer than that (Meta blocked API access for 6 days in
             Aug 2026), every cached URL 403s and the grid fills with broken-image
             icons on a live page. The video path below already self-removes on error;
             images were simply missed. Same idea, two surfaces:
               - homepage gallery: tiles carry a Liquid-rendered block/asset image, so
                 fall BACK to it and keep the tile
               - vial page: feed-only, zero blocks, nothing to fall back to, so hide
                 the tile — which matches how an unpainted tile already behaves
                 (`.plig-tile img:not([src]){opacity:0}`)
             Capture the fallback BEFORE overwriting src, and if the fallback itself
             fails, hide rather than loop. */
          var igFallback = img.getAttribute('src') || '';
          img.addEventListener('error', function () {
            var host = this.closest('a') || this.parentNode;
            if (igFallback && this.getAttribute('src') !== igFallback) {
              this.addEventListener('error', function () {
                if (host) host.style.display = 'none';
              }, { once: true });
              this.src = igFallback;
              this.alt = 'Instagram post';
            } else if (host) {
              host.style.display = 'none';
            }
          }, { once: true });
          img.src = post.image;
          img.removeAttribute('srcset');
          img.alt = post.caption ? post.caption.slice(0, 120) : 'Instagram post';

          /* video tiles: ▶ badge, and the tile links STRAIGHT to the reel —
             one tap and it plays in the Instagram app/site (owner 2026-08-20;
             the embed lightbox cost a second tap and was dropped). In-tile
             muted autoplay still covers posts that expose their MP4. Tiles
             are cloned from tiles[0], so the non-video branch must strip
             what a video template may have carried in. */
          if (post.type === 'VIDEO') {
            if (!$('.smv2-ig-play', tile)) {
              var badge = document.createElement('span');
              badge.className = 'smv2-ig-play';
              badge.setAttribute('aria-hidden', 'true');
              badge.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg>';
              tile.appendChild(badge);
            }
            var wantInline = post.video && !SMV2.reduced &&
              !(navigator.connection && navigator.connection.saveData);
            var vid = $('video', tile);
            if (wantInline) {
              if (!vid) {
                vid = document.createElement('video');
                vid.muted = true; vid.loop = true; vid.playsInline = true;
                vid.setAttribute('playsinline', ''); vid.setAttribute('muted', '');
                vid.preload = 'none';
                vid.addEventListener('error', function () { this.remove(); }, { once: true });
                tile.appendChild(vid);
              }
              vid.poster = post.image;
              vid.setAttribute('data-src', post.video);
              vid.removeAttribute('src');
              watchVideo(vid);
            } else if (vid) vid.remove();
          } else {
            $all('video, .smv2-ig-play', tile).forEach(function (n) { n.remove(); });
          }
        });

        // drop leftover manual tiles so the grid reads as one live feed
        $all('.smv2-ig-tile', grid).slice(items.length).forEach(function (extra) { extra.remove(); });
        scanReveals();
        grid.setAttribute('data-ig-live', '1');
      }

      /* LIVE STORIES (2026-09-09): bubbles in the module's stories rail, one
         per story in the payload (the Worker already dropped anything older
         than 24h). Gradient ring, the story's age as the label, link to the
         story itself — instagram.com/stories/<user>/<id>/ — which the
         Instagram app (our dominant referrer's in-app browser) opens straight
         into. A bubble whose signed image URL has expired removes itself. */
      function paintStories(stories, profile) {
        var section = grid.closest('section') || document;
        var rail = $('[data-ig-stories-rail]', section);
        var slot = $('[data-ig-stories]', section);
        if (!rail || !slot || !stories || !stories.length) return;
        var user = (profile && profile.username) || rail.getAttribute('data-ig-handle') || '';
        var now = Date.now();
        slot.innerHTML = '';
        stories.slice(0, 12).forEach(function (st) {
          if (!st.image || !st.id) return;
          var a = document.createElement('a');
          a.className = 'plig-story plig-story--live';
          a.href = user ? 'https://www.instagram.com/stories/' + user + '/' + st.id + '/' : 'https://www.instagram.com/';
          a.target = '_blank'; a.rel = 'noopener';
          var ts = st.timestamp ? Date.parse(st.timestamp) : 0;
          var age = ts ? Math.max(0, now - ts) : 0;
          var lab = !ts ? 'Now' : age < 3600000 ? Math.max(1, Math.round(age / 60000)) + 'm' : Math.round(age / 3600000) + 'h';
          a.setAttribute('aria-label', 'Story on Instagram, ' + lab + ' ago');
          a.innerHTML = '<span class="plig-story-ring"><span class="plig-story-img"><img alt="" loading="lazy" width="64" height="64"></span></span><span class="plig-story-lab"></span>';
          $('.plig-story-lab', a).textContent = lab;
          var img = $('img', a);
          img.addEventListener('error', function () { a.remove(); if (!$('.plig-story', rail)) rail.hidden = true; }, { once: true });
          img.src = st.image;
          slot.appendChild(a);
        });
        if ($('.plig-story', rail)) rail.hidden = false;
      }

      function load() {
        var ctrl = window.AbortController ? new AbortController() : null;
        var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 6000);
        var url = endpoint + (endpoint.indexOf('?') === -1 ? '?' : '&') + 'limit=' + want;

        fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
          .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status)); })
          .then(function (data) {
            clearTimeout(timer);
            if (!data) return;
            if (data.profile) paintProfile(data.profile);
            if (data.items && data.items.length) paint(data.items.slice(0, want));
            if (data.stories && data.stories.length) paintStories(data.stories, data.profile);
          })
          .catch(function () { clearTimeout(timer); /* manual tiles stand in */ });
      }

      // below the fold — don't spend the request until it's nearly on screen
      if (window.IntersectionObserver) {
        var io = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) {
            if (!en.isIntersecting) return;
            io.disconnect();
            load();
          });
        }, { rootMargin: '400px' });
        io.observe(grid);
      } else load();
    });
  }

  /* ---------- selected-works reel: hand control to the user ---------- */
  /* Touch has no hover, so the marquee would otherwise slide out from under a
     finger mid-swipe. Holding the animation on first contact and releasing it
     once they stop lets the reel keep auto-scrolling while still being grabbable. */
  function initCdwReel(root) {
    $all('.cdw-row', root || document).forEach(function (row) {
      if (row._init) return; row._init = true;
      var timer = null;

      function release() { row.classList.remove('cdw-hold'); }
      function hold() {
        row.classList.add('cdw-hold');
        clearTimeout(timer);
        timer = setTimeout(release, 1800);
      }

      ['pointerdown', 'touchstart', 'scroll', 'wheel'].forEach(function (ev) {
        row.addEventListener(ev, hold, { passive: true });
      });
    });
  }

  /* ---------- header cart badge ---------- */
  /* The badge is server-rendered, so it froze at whatever the cart held when the
     page loaded. Every add/remove on this site goes through a raw fetch to the
     cart AJAX API — the builders, the product drawer, the cart steppers, the fee
     guard — and none of them tell the header about it. Rather than ask each one
     to report in, watch the network layer: any successful call to a cart-mutating
     endpoint triggers one debounced re-read of /cart.js.

     Also re-syncs on bfcache restore and on tab re-focus, which is the other way
     this goes stale — back-button into a cached page, or check out in one tab
     while another sits open. */
  function initCartCount() {
    if (SMV2._cartBound) return; SMV2._cartBound = true;

    var MUTATES = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;
    var timer = null;

    function paint(count) {
      $all('[data-smv2-cart-count]').forEach(function (el) {
        // a 1000-piece order rendered a wide pill — cap the glyph, keep the true
        // number in the link's aria-label below
        // show the true count — bag orders here are 32-1024, so a "99+" cap
        // hid the number the buyer actually wants to read. Comma past 999.
        el.textContent = count > 9999 ? '9999+' : count.toLocaleString('en-US');
        if (count > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
      // the cart link's aria-label was a static "Cart", hiding the count from
      // screen readers — keep it truthful
      $all('[data-smv2-cart-link]').forEach(function (a) {
        a.setAttribute('aria-label', 'Cart, ' + count + ' item' + (count === 1 ? '' : 's'));
      });
    }

    function sync() {
      // cache-busted + no-store: a cached /cart.js is exactly how this drifts
      fetch('/cart.js?t=' + Date.now(), { cache: 'no-store', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart && typeof cart.item_count === 'number') paint(cart.item_count); })
        .catch(function () { /* leave the last known value rather than blanking it */ });
    }

    function schedule() { clearTimeout(timer); timer = setTimeout(sync, 120); }

    // observe fetch without disturbing it — the original promise is returned
    // untouched and the body is never read here
    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function (input, init) {
        var p = origFetch.apply(this, arguments);
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          if (MUTATES.test(url)) p.then(function (res) { if (res && res.ok) schedule(); }, function () {});
        } catch (e) {}
        return p;
      };
    }

    // some legacy sections still post the cart over XHR
    if (window.XMLHttpRequest) {
      var origOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        try { if (MUTATES.test(url || '')) this.addEventListener('load', schedule); } catch (e) {}
        return origOpen.apply(this, arguments);
      };
    }

    window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) sync(); });
    document.addEventListener('cart:updated', schedule);

    sync();   // correct a stale server render (cached HTML, back button) on load
  }

  /* ---------- sticky builder routing ---------- */
  /* An ad drops someone into Easy or the full builder; each builder page stamps
     its path into sm_last_builder. Every builder link on the site then follows
     them back to the one they actually used, so an Easy-mode visitor never gets
     dumped into the full builder by a generic nav link.

     Deliberately narrow about what it rewrites: only the header nav and links
     that opt in with data-smv2-build. The cart's per-line Edit links resolve the
     builder server-side from each line's _src property — which is per-design and
     strictly more accurate than one global "last used" — so rewriting those would
     make routing worse. Anything carrying a query string is skipped for the same
     reason. */
  function initBuilderRoute(root) {
    var cfg = $('[data-smv2-builders]', root || document);
    if (!cfg || cfg._init) return;
    cfg._init = true;

    var easyU = (cfg.getAttribute('data-easy') || '').trim();
    var bldrU = (cfg.getAttribute('data-builder') || '').trim();
    if (!easyU || !bldrU) return;

    function pathOf(u) {
      try { return new URL(u, window.location.origin).pathname.replace(/\/$/, ''); }
      catch (e) { return ''; }
    }

    var last = '';
    try { last = localStorage.getItem('sm_last_builder') || ''; } catch (e) {}
    var lp = pathOf(last);

    // only ever resolve to one of the two KNOWN urls, so a stale or tampered
    // value can never redirect somewhere unexpected.
    // Easy mode is the DEFAULT route (owner call 2026-07-31): no memory — or a
    // memory of some other page, like the jar builder — resolves to Easy. The
    // full builder is unlinked site-wide and reached only by direct URL or by
    // this memory; that keeps returning full-builder users where they were.
    var target = lp === pathOf(bldrU) ? bldrU : easyU;

    var easyP = pathOf(easyU), bldrP = pathOf(bldrU), targetP = pathOf(target);
    var scopes = $all('.dk-pill, [data-smv2-mobile]').concat($all('[data-smv2-build]'));

    scopes.forEach(function (scope) {
      var links = scope.tagName === 'A' ? [scope] : $all('a[href]', scope);
      links.forEach(function (a) {
        var href = a.getAttribute('href') || '';
        if (href.indexOf('?') !== -1) return;          // carries its own state — leave it
        var p = pathOf(href);
        if (p !== easyP && p !== bldrP) return;        // not a builder link
        if (p === targetP) return;
        a.setAttribute('href', target);
      });
    });
  }


  /* ---------- point cloud (home split hero, Peptide Labels door) ----------
     Ported from the Peptide Labels landing prototype: ~720 points in a flattened
     3D ellipsoid, slow Y rotation + X wobble, perspective-projected, depth-shaded,
     gentle pointer parallax, and a small pool of short-lived links between near
     neighbours (a scan finding structure, not a mesh). Canvas 2D at device res.
     Gates: runs only while on screen and the tab is visible; reduced motion
     draws one static frame. Colour from data-color (hex). ---------- */
  function initPoints(root) {
    $all('[data-smv2-points]', root || document).forEach(function (c) {
      if (c._init) return;
      c._init = true;
      var ctx = c.getContext('2d'); if (!ctx) return;
      var prm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      /* phones draw fewer points at a lower device ratio: 720 arcs at dpr 2 is
         ~3M px of canvas per frame, fine on a laptop GPU, unproven on a
         three-year-old Android. The cloud reads the same at 420 — it is the
         motion and the links that sell it, not the count. */
      var coarse = window.matchMedia('(pointer: coarse)').matches;
      var N = coarse ? 420 : 720, pts = [];
      function h(n) { var x = Math.sin(n * 12.9898 + 78.233) * 43758.5453; return x - Math.floor(x); }
      for (var i = 0; i < N; i++) {
        var u = h(i * 3 + 1) * 2 - 1, v = h(i * 3 + 2) * 2 - 1, w = h(i * 3 + 3) * 2 - 1;
        var r = Math.sqrt(u * u + v * v + w * w); if (r === 0) r = 1;
        var k = Math.pow(h(i * 7 + 5), .35);
        pts.push({ x: u / r * k * 1.7, y: v / r * k * .55, z: w / r * k, s: .6 + h(i * 11 + 9) * 1.4 });
      }
      var col = [143, 208, 255];
      var hex = (c.getAttribute('data-color') || '').trim();
      if (/^#[0-9a-f]{6}$/i.test(hex)) { var n = parseInt(hex.slice(1), 16); col = [n >> 16 & 255, n >> 8 & 255, n & 255]; }
      var links = []; for (var q = 0; q < 10; q++) links.push({ a: 0, b: -1, t: 99, life: 1 + q * .4 });
      var px = 0, py = 0, tx = 0, ty = 0, seen = true, raf = 0, dpr = Math.min(coarse ? 1.5 : 2, window.devicePixelRatio || 1);
      document.addEventListener('pointermove', function (e) { tx = (e.clientX / window.innerWidth - .5); ty = (e.clientY / window.innerHeight - .5); }, { passive: true });
      /* park the hero's OTHER perpetual animations (ghost marquee, logo reel)
         with the same visibility gate the cloud uses — three infinite
         animations running under a scrolled-away hero is battery for nothing.
         CSS does the pausing off [data-smv2-parked]; the canvas is the sensor. */
      var park = c.closest('[data-smv2-park]');
      /* the park attribute gets its OWN observer on the park element: the canvas
         can be display:none (phones — the cloud is desktop-only), and a hidden
         canvas never intersects, which would park the marquee permanently. */
      if (park && 'IntersectionObserver' in window && !park._parkIO) {
        park._parkIO = new IntersectionObserver(function (es) {
          park.toggleAttribute('data-smv2-parked', !es[0].isIntersecting);
        }, { rootMargin: '80px' });
        park._parkIO.observe(park);
      }
      function size() { var w = c.clientWidth, hh = c.clientHeight; if (c.width !== Math.round(w * dpr) || c.height !== Math.round(hh * dpr)) { c.width = Math.round(w * dpr); c.height = Math.round(hh * dpr); } }
      var t0 = performance.now();
      function frame(now) {
        size();
        var W = c.width, H = c.height, t = (now - t0) / 1000;
        if (!W || !H) { raf = 0; return; }
        px += (tx - px) * .04; py += (ty - py) * .04;
        var ay = t * .12 + px * .8, ax = Math.sin(t * .17) * .18 + py * .5;
        var cy = Math.cos(ay), sy = Math.sin(ay), cx = Math.cos(ax), sx = Math.sin(ax);
        var R = Math.max(Math.min(W, H) * .62, W * .34), cxp = W * .5, cyp = H * .52, f = 3.2;
        ctx.clearRect(0, 0, W, H);
        for (var i = 0; i < N; i++) {
          var p = pts[i];
          var x1 = p.x * cy + p.z * sy, z1 = -p.x * sy + p.z * cy;
          var y1 = p.y * cx - z1 * sx, z2 = p.y * sx + z1 * cx;
          var d = f / (f - z2), X = cxp + x1 * R * d, Y = cyp + y1 * R * d;
          // brighter + larger than the prototype's: that cloud sat on white paper, this one on #0b0c0f
          var a = Math.max(.06, Math.min(.72, (z2 + 1) * .36));
          var rad = p.s * d * dpr * .85;
          ctx.fillStyle = 'rgba(' + col[0] + ',' + col[1] + ',' + col[2] + ',' + a.toFixed(3) + ')';
          ctx.beginPath(); ctx.arc(X, Y, rad, 0, 6.2832); ctx.fill();
          p._X = X; p._Y = Y; p._a = a;
        }
        for (var li = 0; li < links.length; li++) {
          var L = links[li];
          L.t += 1 / 60;
          if (L.t > L.life) {
            var iA = Math.floor(h(now * .001 + li * 17.3) * N), best = -1, bd = 1e9, pa = pts[iA];
            for (var j = 0; j < 40; j++) { var iB = Math.floor(h(now * .0013 + li * 5.7 + j * 31.1) * N); if (iB === iA) continue; var pb = pts[iB]; var dd = (pa.x - pb.x) * (pa.x - pb.x) + (pa.y - pb.y) * (pa.y - pb.y) + (pa.z - pb.z) * (pa.z - pb.z); if (dd < bd) { bd = dd; best = iB; } }
            L.a = iA; L.b = best < 0 ? (iA + 1) % N : best; L.t = 0; L.life = 2.2 + h(now * .002 + li) * 3.5;
          }
          if (L.b < 0) continue;
          var A = pts[L.a], B = pts[L.b];
          var life = L.t / L.life, env = life < .2 ? life / .2 : life > .8 ? (1 - life) / .2 : 1;
          var la = Math.min(A._a, B._a) * .9 * env;
          if (la < .01) continue;
          ctx.strokeStyle = 'rgba(' + col[0] + ',' + col[1] + ',' + col[2] + ',' + la.toFixed(3) + ')';
          ctx.lineWidth = dpr * .7;
          ctx.beginPath(); ctx.moveTo(A._X, A._Y); ctx.lineTo(B._X, B._Y); ctx.stroke();
        }
        if (!prm && seen && !document.hidden) raf = requestAnimationFrame(frame); else raf = 0;
      }
      function kick() { if (!raf) raf = requestAnimationFrame(frame); }
      kick();
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { seen = es[0].isIntersecting; if (seen) kick(); }, { rootMargin: '80px' }).observe(c);
      document.addEventListener('visibilitychange', function () { if (!document.hidden) kick(); });
      window.addEventListener('resize', function () { if (prm) { raf = 0; requestAnimationFrame(frame); } }, { passive: true });
    });
  }


  /* ---------- animated grid pattern (home split hero, PL room) ----------
     Port of sv-animations' AnimatedGridPattern: an SVG cell grid (top+left
     hairline per cell) with N squares that fade in to maxOpacity and back
     out, then hop to a new random cell — staggered so the field shimmers.
     Vanilla: the grid is one <pattern>, the squares are WAAPI animations
     (opacity only, compositor-cheap). Config via data- attrs on the host
     ([data-smv2-gridpat]): data-cell, data-squares, data-maxo, data-dur,
     data-rdelay, data-color. Gates: reduced motion renders the grid plus a
     few static squares; the shared [data-smv2-park] attribute pauses every
     square while the hero is off-screen; a 0-width host (the room is
     display:none on phones) does nothing until a resize shows it. ---------- */
  var gridpatSeq = 0;
  function initGridPat(root) {
    $all('[data-smv2-gridpat]', root || document).forEach(function (host) {
      if (host._init) return;
      host._init = true;
      var NS = 'http://www.w3.org/2000/svg';
      var prm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var cell = parseInt(host.getAttribute('data-cell'), 10) || 32;
      var N = parseInt(host.getAttribute('data-squares'), 10) || 26;
      var maxO = parseFloat(host.getAttribute('data-maxo')) || .14;
      var dur = (parseFloat(host.getAttribute('data-dur')) || 3) * 1000;
      var rdelay = (parseFloat(host.getAttribute('data-rdelay')) || 1) * 1000;
      var col = host.getAttribute('data-color') || '#8fd0ff';
      var svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('aria-hidden', 'true');
      svg.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;';
      var defs = document.createElementNS(NS, 'defs');
      var pid = 'smv2gridpat' + (++gridpatSeq);
      var pat = document.createElementNS(NS, 'pattern');
      pat.setAttribute('id', pid);
      pat.setAttribute('width', cell);
      pat.setAttribute('height', cell);
      pat.setAttribute('patternUnits', 'userSpaceOnUse');
      var path = document.createElementNS(NS, 'path');
      path.setAttribute('d', 'M.5 ' + cell + 'V.5H' + cell);
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', col);
      path.setAttribute('stroke-opacity', '.07');
      pat.appendChild(path);
      defs.appendChild(pat);
      svg.appendChild(defs);
      var bg = document.createElementNS(NS, 'rect');
      bg.setAttribute('width', '100%');
      bg.setAttribute('height', '100%');
      bg.setAttribute('fill', 'url(#' + pid + ')');
      svg.appendChild(bg);
      host.appendChild(svg);
      var rects = [];
      function measure() { return { w: host.clientWidth, h: host.clientHeight }; }
      function place(r) {
        var d = measure();
        if (!d.w || !d.h) return false;
        r.setAttribute('x', Math.floor(Math.random() * (d.w / cell)) * cell + 1);
        r.setAttribute('y', Math.floor(Math.random() * (d.h / cell)) * cell + 1);
        return true;
      }
      function launch(r, delay) {
        if (!place(r)) return; // hidden host — reawakened by the resize listener
        r._anim = r.animate(
          [{ opacity: 0 }, { opacity: maxO }, { opacity: 0 }],
          { duration: dur * 2, delay: delay, easing: 'ease-in-out' }
        );
        r._anim.onfinish = function () { launch(r, Math.random() * rdelay); };
      }
      function build() {
        if (rects.length || !measure().w) return;
        for (var i = 0; i < N; i++) {
          var r = document.createElementNS(NS, 'rect');
          r.setAttribute('width', cell - 1);
          r.setAttribute('height', cell - 1);
          r.setAttribute('fill', col);
          r.setAttribute('opacity', '0');
          svg.appendChild(r);
          rects.push(r);
          if (prm) {
            // reduced motion: a static scattering, no animation
            if (i % 4 === 0 && place(r)) r.setAttribute('opacity', String(maxO * .6));
          } else {
            launch(r, i * 100);
          }
        }
      }
      build();
      window.addEventListener('resize', build, { passive: true });
      var park = host.closest('[data-smv2-park]');
      if (park && !prm && 'MutationObserver' in window) {
        new MutationObserver(function () {
          var p = park.hasAttribute('data-smv2-parked');
          rects.forEach(function (r) { if (r._anim) { if (p) r._anim.pause(); else r._anim.play(); } });
        }).observe(park, { attributes: true, attributeFilter: ['data-smv2-parked'] });
      }
    });
  }


  /* ---------- logo carousel (home split hero) ----------
     Port of sv-animations' LogoCarousel, sampling variant (owner 2026-08-19:
     "three logos always showing, a random assortment"): instead of fixed
     groups (7 logos = 3/3/1, a lonely final set), every cycle draws `count`
     logos at random from the pool — never the set currently on screen — so a
     full row always shows. The originals stay hidden in the host as the pool;
     each set is built from clones. Swap animation is the component's verbatim
     (40px rise + 4px blur, 600ms ease, 140ms stagger). Gates: reduced motion
     swaps plainly; ticks skip while the tab is hidden or the hero is parked
     ([data-smv2-park]); a pool no bigger than one set renders static. */
  function initLogoCycle(root) {
    $all('[data-smv2-logocycle]', root || document).forEach(function (host) {
      if (host._init) return;
      host._init = true;
      var prm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var count = parseInt(host.getAttribute('data-count'), 10) || 3;
      var interval = parseInt(host.getAttribute('data-interval'), 10) || 2600;
      var STAG = 140, DUR = 600;
      var pool = Array.prototype.slice.call(host.children);
      if (!pool.length) return;
      host.classList.add('smv2-lc');
      pool.forEach(function (img) { img.hidden = true; }); // originals = the pool, never shown
      function sample(exclude) {
        var cand = pool.filter(function (p) { return exclude.indexOf(p) === -1; });
        // top up from the excluded set only when the pool is too small to avoid it
        while (cand.length < count && exclude.length) cand.push(exclude[(Math.random() * exclude.length) | 0]);
        var out = [];
        while (out.length < Math.min(count, cand.length)) {
          var pick = cand[(Math.random() * cand.length) | 0];
          if (out.indexOf(pick) === -1) out.push(pick);
        }
        return out;
      }
      function buildGroup(srcs, cls) {
        var d = document.createElement('div');
        d.className = 'smv2-lc-group is-on';
        srcs.forEach(function (src, ii) {
          var img = src.cloneNode(true);
          img.hidden = false;
          img.style.animationDelay = (ii * STAG) + 'ms';
          img.style.animationDuration = DUR + 'ms';
          if (cls) img.classList.add(cls);
          d.appendChild(img);
        });
        host.appendChild(d);
        return d;
      }
      // the first set is the first N in pool order — the same three the CSS
      // first-paint state already shows — so the JS handover is invisible
      var current = pool.slice(0, count);
      var curEl = buildGroup(current, null);
      if (pool.length <= count) return; // nothing to rotate to — a static row
      var park = host.closest('[data-smv2-park]');
      setInterval(function () {
        if (document.hidden) return;
        if (park && park.hasAttribute('data-smv2-parked')) return;
        var next = sample(current);
        var old = curEl;
        if (prm) { // reduced motion: a plain swap, no travel, no blur
          old.remove();
          curEl = buildGroup(next, null);
        } else {
          Array.prototype.forEach.call(old.children, function (img) { img.classList.add('smv2-lc-exit'); });
          curEl = buildGroup(next, 'smv2-lc-enter');
          setTimeout(function () { old.remove(); }, DUR + count * STAG);
        }
        current = next;
      }, interval);
    });
  }
  /* ---------- boot ---------- */
  function init() {
    scanReveals();
    cache();
    initPricing();
    initFaq();
    initScrollers();
    initHeader();
    initWorkLightbox();
    initEduJump();
    initStepsNav();
    initReelFlip();
    initReelGlide();
    initReelTap();
    initReelPower();
    initBeforeAfter();
    initIgFeed();
    initCdwReel();
    initBuilderRoute();
    initCartCount();
    initPoints();
    initGridPat();
    initLogoCycle();
    frame();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', function () { init(); });
  document.addEventListener('shopify:section:unload', function () { cache(); });

  /* SIGN-IN ANSWERS AT ONCE (Clarity 2026-09-29..10-06: in the Instagram / Facebook in-app browsers the hosted
     login is a slow cross-site redirect, nothing on the page changed, the first tap read as dead and people
     tapped again ~2 s later). Every a[data-sm-signin] now says "Opening sign-in…" the moment it is tapped and
     swallows the repeat; a page restored from the back-forward cache, or a redirect that never left after 8 s,
     puts it back. The label lives on [data-sm-signin-tx] inside the link when the link holds more than text. */
  function signinLabel(a) { return a.querySelector('[data-sm-signin-tx]') || a; }
  function signinReset(a) {
    a.classList.remove('is-signing'); a.removeAttribute('aria-busy');
    if (a._smSigninTx != null) signinLabel(a).textContent = a._smSigninTx;
    clearTimeout(a._smSigninT);
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-sm-signin]') : null;
    if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.getAttribute('aria-busy') === 'true') { e.preventDefault(); return; }
    var tx = signinLabel(a);
    if (a._smSigninTx == null) a._smSigninTx = tx.textContent;
    a.classList.add('is-signing'); a.setAttribute('aria-busy', 'true');
    tx.textContent = a.getAttribute('data-sm-signin-busy') || 'Opening sign-in…';
    a._smSigninT = setTimeout(function () { signinReset(a); }, 8000);
  });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    $all('a[data-sm-signin].is-signing').forEach(signinReset);
  });
})();
